import type { AppVariant } from './types';
import { getPackHeaderTranslated } from '../i18n/helpers';

/** Display name and phrase for each app variant (game setup header, loading shell, etc.) */
export function getPackHeader(variant: string): { name: string; phrase: string } {
  return getPackHeaderTranslated(variant);
}
